import React, { Suspense } from 'react';
import './AnimationRoute.css';
import { Route, Switch, Redirect } from 'react-router';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Loader from '../Loader/Loader';

const About = React.lazy(() => import('../Routes/About'));
const Blog = React.lazy(() => import('../Routes/Blog'));
const Ideas = React.lazy(() => import('../Routes/Ideas'));
const Projects = React.lazy(() => import('../Routes/Projects'));

const AnimationRoute = () =>
    <Route
        render={({ location }) => (
            <div className="app-content">
                <div className="app-route">
                    <TransitionGroup>
                        <CSSTransition
                            key={location.key}
                            classNames="fade"
                            timeout={{ enter: 500, exit: 0 }}>
                            <Suspense fallback={<Loader isLoading={true} />}>
                                <Switch location={location}>
                                    <Route path="/" exact>
                                        <About />
                                    </Route>
                                    <Route path="/about/">
                                        <About />
                                    </Route>
                                    <Route path="/blog/">
                                        <Blog />
                                    </Route>
                                    <Route path="/ideas/">
                                        <Ideas />
                                    </Route>
                                    <Route path="/projects/">
                                        <Projects />
                                    </Route>
                                    <Route render={() => <Redirect to="/" />} />
                                </Switch>
                            </Suspense>
                        </CSSTransition>
                    </TransitionGroup>
                </div>
            </div>
        )} />;

export default AnimationRoute;